import Slider from 'javascripts/globals/slider';

class HomeSlider extends Slider {
  constructor($el, config) {
    super($el, config);
    this.$el = $el;
    this.$controls = this.$el.querySelector('.stage-home__controls');
    this.$figure = this.$el.querySelector('.figure__media');
  }
}

const componentStore = [];

document.querySelectorAll('.stage-home').forEach(($homeSlider) => {
  componentStore.push(new HomeSlider($homeSlider, {
    sliderFrame: 'stage-home__frame',
    slidesContainer: 'stage-home__items',
    sliderSlide: 'stage-home__item',
    sliderControlsframe: 'stage-home__controls',
    sliderControlsframemethod: 'prepend',
    sliderDotsframe: 'stage-home__dots',
    sliderDotsframemethod: 'append',
    controlPrevIcon: 'slider-arrow-left',
    controlNextIcon: 'slider-arrow-right',
    controlIconViewBox: '0 0 800 200',
  }));
});
